import { cn } from '@sohanemon/utils';
import * as m from 'motion/react-m';
import { AnimatePresence } from 'motion/react';
import { useEffect, useState } from 'react';
import { MotionProvider } from './motion';

interface TextRotateProps {
	texts: string[];
	interval?: number;
	className?: string;
}

export function TextRotate({
	texts,
	interval = 5000,
	className,
}: TextRotateProps) {
	const [index, setIndex] = useState(0);

	useEffect(() => {
		const id = setInterval(
			() => setIndex((i) => (i + 1) % texts.length),
			interval,
		);
		return () => clearInterval(id);
	}, [texts.length, interval]);

	return (
		<MotionProvider>
			<span className={cn('inline-flex overflow-hidden', className)}>
				<AnimatePresence mode="wait" initial={false}>
					<m.span
						key={texts[index]}
						initial={{ y: '60%', opacity: 0, scale: 0.8 }}
						animate={{ y: 0, opacity: 1, scale: 1 }}
						exit={{ y: '-60%', opacity: 0, scale: 0.8 }}
						transition={{ duration: 0.4, ease: 'easeInOut' }}
						className="inline-block whitespace-pre"
					>
						{texts[index]}
					</m.span>
				</AnimatePresence>
			</span>
		</MotionProvider>
	);
}
